import { MaterializeAction } from "angular2-materialize";
import { EventEmitter } from "@angular/core";
import { PdfmakeService } from "ng-pdf-make";

export type ContentCell = any;
export interface PdfElements {
  h1: any;
  h2: any;
  h3: any;
  span: any;
  img: any;
  table: any;
  tableHeader: any;
  column: any;
  pageBreak: any;
}
import { Utils } from "./util";
import { PdfMargin, PdfOrientation, PdfPageSize, PdfSettingsKeys, PdfmakeServiceType } from './globals';
import { stringify } from "querystring";

interface CollapParams { onOpen?: () => any, onClose?: () => any }
export class Collapsible {

    actions = new EventEmitter<string|MaterializeAction>();
    params: CollapParams[];

    constructor(params: CollapParams[] = []){
        this.params = params;
    }

    open(index: number = 0) {
      this.actions.emit({action:"collapsible",params: <any>['open', index]});
    }

    close(index: number = 0) {
      this.actions.emit({action:"collapsible",params: <any>['close', index]});
    }
}

interface ModalParams{ dismissible: boolean }
export class NgModal{
    actions = new EventEmitter<string|MaterializeAction>();
    params: ModalParams[];

    constructor(params: ModalParams[] = [{dismissible: true}]){
        this.params = params;
    }

    open(){
      this.actions.emit({action:"modal",params: <any>['open']});
    }

    close(){
      this.actions.emit({action:"modal",params: <any>['close']});
    }
  
}


export class NgTable<T = any>{

  data: T[];
  rows: T[] = [];
  columns: Array<any>;

  page = 1;
  itemsPerPage = 10;
  maxSize = 5;
  numPages = 1;
  length = 0;
  config = {
  paging: true,
  sorting: undefined,
  filtering: { filterString: '' },
  api: undefined
  };

  constructor({ api={}, columns, data, itemsPerPage=10, onCellClick=()=>{}, filter='' }: {api?: any, columns: any[], data: T[], itemsPerPage?: number, onCellClick?: any, filter?: string}){
      this.config.api = api;
      this.config.sorting = { columns };
      this.config.filtering.filterString = filter;
      this.columns = columns;
      this.data = data;
      this.itemsPerPage = itemsPerPage;
      this.length = data.length;
      this.onCellClick = onCellClick;
      this.onChangeTable(this.config);
  }

  onCellClick;

  // *************** Table functionality *************** //
changePage(page: any, data: Array<any> = this.data): Array<any> {
  let start = (page.page - 1) * page.itemsPerPage;
  let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

  return data.slice(start, end);
}

changeSort(data: any, config: any): any {
  if (!config.sorting) {
    return data;
  }

  let columns = this.config.sorting.columns;
  let columnName: string;
  let sort: string;

  for (let i = 0; i < columns.length; i++) {
    if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
      columnName = columns[i].name;
      sort = columns[i].sort;
    }
  }

  if (!columnName) {
    return data;
  }

  // simple sorting
  return data.sort((previous: any, current: any) => {
    if (previous[columnName] > current[columnName]) {
      return sort === 'desc' ? -1 : 1;
    } else if (previous[columnName] < current[columnName]) {
      return sort === 'asc' ? -1 : 1;
    }

    return 0;
  });
}

changeFilter(data: any, config: any): any {
      let filteredData: Array<any> = data;

  this.columns.map((column: any) => {
    if (column.filtering) {
      filteredData = filteredData.filter((item: any) => {
        return item[column.name].match(column.filtering.filterString);
      });
    }
  });

  if (!config.filtering) {
    return filteredData;
  }

  if (config.filtering.columnName) {
    return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
  }

  let tempArray: Array<any> = [];

  filteredData.map((item: any) => {
    let flag = false;

    this.columns.map(({name=''}: any) => {
      if (item[name] &&
        item[name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
        flag = true;
      }
    });

    if (flag) {
      tempArray.push(item);
    }
  });

  filteredData = tempArray;

  return filteredData;
}

onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
  if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
  }

  if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
  }

  let filteredData = this.changeFilter(this.data, this.config);
  let sortedData = this.changeSort(filteredData, this.config);

  this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
  this.length = sortedData.length;
}
}


export class Pdf{
  service: PdfmakeServiceType;
  public get content(): ContentCell[] { return this.service ? this.service.docDefinition.content : [] }

  
  jsonDataColumnsVencimiento = [{title: 'fechas', span: 2, style: 'tableHeader'},{title: 'dias', span: 1, style: 'tableHeader'},{title: 'xvencer', span: 2, style: 'tableHeader'},{title: 'password', span: 1, style: 'tableHeader'},{title: 'id', span: 1, style: 'tableHeader'}]
  jsonDataVencimiento = [
    { fechas: '28/02/20', dias: 2, email: "gmail.com", password: 123},
    { fechas: '28/02/20', dias: 4, email: "email.com", password: 234},
    { fechas: '28/02/20', dias: 3, email: "hotmail.com", password: 345, id: '123456' },
    { fechas: '28/02/20', dias: 4, email: "mpmail.com", password: 654, id: '654321' },
    { fechas: '28/02/20', dias: 5, email: "hotmail.com", password: 148, id: '123456' }
  ];

  jsonDataHeaderColumnsVencimiento = [{title: 'fechas', span: 1, style: 'tableHeader'},{title: 'dias', span: 1, style: 'tableHeader'},{title: 'por Vencer', span: 1, style: 'tableHeader'},{title: 'vencido', span: 1, style: 'tableHeader'},{title: 'saldo', span: 1, style: 'tableHeader'}]
  jsonDataHeaderVencimiento = [];
  


  loremText = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum"

  promiseCount: number = 0;
  promiseFullfilled: number = 0;
  //private get images(): {[id: string]: string} { return this.service ? this.service.docDefinition.images : {} }
  constructor({margins='l', orientation='portrait', pageSize='A4'}: {margins?: keyof PdfMargin, orientation?: PdfOrientation, pageSize?: PdfPageSize} = {}){
    this.service = <any> new PdfmakeService();
    // window['pdf'] = service;
    this.service.docDefinition.content = [];
    this.service.docDefinition.pageSize = pageSize;
    this.service.docDefinition.pageMargins = PdfSettingsKeys.pageMargins[margins];
    this.service.docDefinition.pageOrientation = orientation
    this.service.docDefinition.styles = <any>{
      h1: {},
      h2: {},
      h3: {},
      span: {},
      img: {},
      table: {},
      tableHeader: {},
      column: {},
      pageBreak: {}
    }
  }

  add(index: number, row: ContentCell){
    this.content[index] = row;
  }

  defineSettings(reportType: string, margins: string, orientation: string, paperSize: string, styles: string){ 
    
    switch (reportType) {
      case 'Adeudos':



      

        break;
      case 'Pagos':
        
        break;
      case 'Apuntador':
        
        break;
      case 'Produccion':
        
        break;

    
      default:



        break;
    }




  }

  /**
   * @param opts: options for the created element
   */
  touchAbs: (opts?: {x?: number, y?: number}) => {[K in keyof PdfElements]: (...params: any[]) => Promise<[number, ContentCell]>} = ({x, y} = {}) => {
    this.promiseCount++;
    let {length: index} = this.service.docDefinition.content;
    this.service.docDefinition.content.push(null);
    return {
      h1: async text => {this.promiseFullfilled++ ; return [index, { text, 
        absolutePosition: x && y ? {x, y} : undefined, 
        style: 'h1' }]},

      h2: async text => {this.promiseFullfilled++ ; return [index, { text, 
        absolutePosition: x && y ? {x, y} : undefined,
        style: 'h2' }]},

      h3: async text => {this.promiseFullfilled++ ; return [index, { text, 
        absolutePosition: x && y ? {x, y} : undefined,
        style: 'h3' }]},

      span: async text => {this.promiseFullfilled++ ; return [index, { text, 
        absolutePosition: x && y ? {x, y} : undefined,
        style: 'span' }]},

      img: async (src, width, height) => {
        let dataUrl: string = await Utils.toDataUrl(src);
        this.promiseFullfilled++;
        return [index, { image: dataUrl, 
          absolutePosition: x && y ? {x, y} : undefined, 
          width, height, style: 'img'}]
      },

      table: async (data, columns, includeHeaders, includeBorder) => {
        
        console.log(includeHeaders);
        console.log(columns);
        
        let abs = {absolutePosition: x && y ? {x, y} : undefined}
        let table = this.createTable(data, columns, includeHeaders, includeBorder, abs);
        this.promiseFullfilled++;
        // return [index, {table, absolutePosition: x && y ? {x, y} : undefined}]
        return [index,
          table
        ]
      },

      tableHeader: async text => {this.promiseFullfilled++ ; return [index, { text, 
        absolutePosition: {x, y}, 
        style: 'tableHeader' }]},

      column: async (data, width, columnGap) => {
        this.promiseFullfilled++;
        return [index, { columns: data, width , columnGap, style: 'column' }]
      },

      pageBreak: async position => {this.promiseFullfilled++ ; return [index, {text:"", pageBreak: position}]}

      
    }
  };


  // addElement(elementName:String, elementContent:any[], fixedSize: boolean, height: 0, width: 0, ){

  //   switch (elementName) {
  //     case 'h1':
        
  //       break;
  //     case 'table':

  //       break;
    
  //     default:
  //       break;
  //   }
  // }
  // addUnorderedList(stringsArray: string[]){
  //   this.service.addUnorderedlist(stringsArray);
  //   console.log(this.content);
  // }

  // addTable(stringsMatrix: string[][]){
  //   let row = new Row(["3"]["3"])
  //   let table = new Table(row,row["3"],["1"]["2"])
  //   this.service.addTable(table)
  //   console.log(this.content);
    
  // }

  createTable(data, columns, includeHeaders, includeBorder, abs){
   return this.configureTable(data, columns, includeHeaders, includeBorder, abs)
  }

  configureTable(data, columns, includeHeaders, includeBorder, abs) {

    var widths= [];

    columns.forEach(element => {

      console.log("width of column:", element.columnWidth);
      widths.push(element.columnWidth)
    });

    let layout = (includeBorder==true) ? '' : 'noBorders'
    console.log("TableLayout:", layout);
    
 
  return {
      table: {
          headerRows: 1,
          body: this.buildTableBody(data, columns, includeHeaders, includeBorder),
          widths: widths,
          
          
      },
      style: 'table',
      layout: layout,
      absolutePosition: abs.absolutePosition
  };

  }
  buildTableBody(data, columns: [{title: string, span: number, style: string[], rowStyle: string[]}], includeHeaders, includeBorder) {
    var body = [];
    var columnTitles = [];

    // for (let number = 0; number < colNmbr; number++) {
    //   let columnTitle: {text: string, colSpan: number }
    //   columnTitle =  {text: columns[number].charAt(0).toUpperCase() + columns[number].slice(1), colSpan: 2}  
    //   columnTitles.push(columnTitle); 
      
    // }
    // console.log(columnTitles);
    



    columns.forEach(function(title) {
      let columnTitle: {text: string, colSpan: number, style: string[] }
      let titleString = title.title.charAt(0).toUpperCase() + title.title.slice(1)
      titleString = titleString.replace(/_/g, ' ');
      columnTitle =  {text: titleString, colSpan: title.span, style: title.style}
      columnTitles.push(columnTitle);
    });
    
    console.log(includeHeaders);
    
    if (includeHeaders == true){
      body.push(columnTitles)
    }
   

    data.forEach(function(row) {
        var dataRow = [];
        let newRow : {text: string, colSpan: number, style: string }
        let spanCounter = 0
        columns.forEach(function(column) {
          if (row[column.title]){
            console.log(row[column.title]);
            console.log(column.rowStyle)
            
            if (column.rowStyle == ['firstItem']){
              dataRow.push({text: row[column.title].toString(), style: column.rowStyle, colSpan: 2})
            }else{
              dataRow.push({text: row[column.title].toString(), style: column.rowStyle, colSpan: 1})
            }
            
      
          }
          else{

            console.log("Else rowstyle: ", column.rowStyle);
            
            if (column.rowStyle[0] == 'firstItem' && includeHeaders == false){
              dataRow.push({text: '', layout: 'noBorders', colSpan: 5})
              console.log("Yes");
              
            }else{
              console.log("No");
              dataRow.push({text: '', colSpan: 1})
        
            }
            
            
          }
          // console.log(row[column]);
          
          // newRow = { text: text, colSpan: 1}
          // dataRow.push(newRow)

        })
        
        body.push(dataRow);
    });
    console.log(body);

    return body;
  }


  

  


  open(){
    let int = setInterval(() => {
      if(this.promiseFullfilled < this.promiseCount) return console.log('waiting to fullfilled');
      clearInterval(int);
      this.service.open();
    }, 200);
  }
}








